import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { getCookie } from "typescript-cookie";
import {
  useLazyGetUnitMeasurementListQuery
} from "../../redux/api/handBooksApi/unitMeasurementApi";
import { EntUnitMeasurementFilter } from "../../models/filters/unitMeasurementFilter";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntUnitMeasurement } from "../../models/handBooks/unitMeasurement";

interface IProps {
  value?: number | null;
  onChange?: () => void;
  measurementCategoryAlias?: string | null;
}

const SelectUnitMeasurement = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [getData] = useLazyGetUnitMeasurementListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntUnitMeasurement, EntUnitMeasurementFilter>({
    initialFilter: new EntUnitMeasurementFilter(),
    query: getData
  });

  useEffect(() => {
    if (props.measurementCategoryAlias) {
      const filter = new EntUnitMeasurementFilter();
      filter.measurementCategoryAlias = props.measurementCategoryAlias;
      setFilter(filter);
      setData([]);
      setCurrentPage(0);
      setFetching(true);
    } else {
      setOptions([]);
      setData([]);
    }
  }, [props.measurementCategoryAlias]);

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntUnitMeasurementFilter();
    filter.name = value;
    filter.measurementCategoryAlias = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new EntUnitMeasurementFilter();
    filter.measurementCategoryAlias = null;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  return (
    <Select
        placeholder={t("msg.selectPlaceholder")}
        onClear={clear}
        onSearch={search}
        onPopupScroll={scrollHandler}
        loading={fetching}
        value={props.value}
        onChange={props.onChange}
        options={options}
        filterOption={defaultFilterOption}
        showSearch
        allowClear
        dropdownRender={(menu) => (
            <Spin spinning={fetching}>
              {menu}
            </Spin>
        )}
    />
  );
};

export default SelectUnitMeasurement;